<template>
  <!-- 新建楼层 -->
  <div class="form">
    <!-- 表单区域 -->
    <div class="container">
      <el-form ref="formRef" :model="formData" label-width="200px">
        <h4>楼层--编号规则</h4>
        <el-divider></el-divider>
        <el-row>
          <el-col span="12">
            <el-form-item
              label="楼层号："
              prop="floorCode"
              :rules="
                formRules.num.concat([{ required: true, message: '请输入楼层号', trigger: 'blur' }])
              "
            >
              <el-input
                v-model="formData.floorCode"
                placeholder="请输入 楼层号"
                maxlength="3"
                clearable
              >
                <template slot="append">/层</template>
              </el-input>
            </el-form-item>
            <!-- <el-form-item label="楼层号：" required>
              <div class="form-item-connector">
                <el-form-item prop="buildingCode">
                  <el-input v-model="formData.buildingCode" disabled></el-input>
                </el-form-item>
                <span>栋</span>
                <el-form-item
                  prop="floorCode"
                  :rules="formRules.num.concat([{ required: true, message: '请输入楼层号', trigger: 'blur' }])"
                >
                  <el-input v-model="formData.floorCode" maxlength="3" clearable></el-input>
                </el-form-item>
                <span>层</span>
              </div>
            </el-form-item> -->
          </el-col>
        </el-row>

        <h4>房间--编号规则</h4>
        <el-divider></el-divider>
        <el-row>
          <el-col span="12">
            <el-form-item prop="floorRoomNum" label="房间数量：" :rules="formRules.num">
              <el-input
                v-model="formData.floorRoomNum"
                placeholder="请输入 房间数量"
                maxlength="2"
                clearable
              >
                <template slot="append">/层</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="roomTowardType"
              label="房间朝向："
              :rules="
                formData.floorRoomNum
                  ? [{ required: true, message: '请选择房间朝向', trigger: 'change' }]
                  : []
              "
            >
              <el-select
                @change="clearValidate('roomTowardType')"
                v-model="formData.roomTowardType"
                placeholder="请选择 房间朝向"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in dirDict"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item prop="roomNameWithConnectorFlag" label="房间号是否带楼栋编号：">
              <el-radio-group v-model="formData.roomNameWithConnectorFlag">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="连接符：">
              <div class="form-item-connector">
                <span>楼栋号</span>
                <el-form-item prop="roomConnectorOne" :rules="formRules.connector">
                  <el-input v-model="formData.roomConnectorOne" clearable></el-input>
                </el-form-item>
                <span>楼层号</span>
                <el-form-item prop="roomConnectorTwo" :rules="formRules.connector">
                  <el-input v-model="formData.roomConnectorTwo" clearable></el-input>
                </el-form-item>
                <span>房间号</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <h4>床位--编号规则</h4>
        <el-divider></el-divider>
        <el-row>
          <el-col span="12">
            <el-form-item prop="roomBedNum" label="床位数量：" :rules="formRules.num">
              <el-input
                v-model="formData.roomBedNum"
                placeholder="请输入 床位数量"
                maxlength="2"
                clearable
              >
                <template slot="append">/间</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="towardType"
              label="床位朝向："
              :rules="
                formData.roomBedNum
                  ? [{ required: true, message: '请选择床位朝向', trigger: 'change' }]
                  : []
              "
            >
              <el-select
                @change="clearValidate('towardType')"
                v-model="formData.towardType"
                placeholder="请选择 床位朝向"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in dirDict"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="bedTypeId"
              label="床位类型："
              :rules="
                formData.roomBedNum
                  ? [{ required: true, message: '请选择床位类型', trigger: 'change' }]
                  : []
              "
            >
              <el-select
                @change="clearValidate('bedTypeId')"
                v-model="formData.bedTypeId"
                placeholder="请选择 床位类型"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in bedTypes"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="nursingType"
              label="护理类型："
              :rules="
                formData.roomBedNum
                  ? [{ required: true, message: '请选择护理类型', trigger: 'change' }]
                  : []
              "
            >
              <el-select
                @change="clearValidate('nursingType')"
                v-model="formData.nursingType"
                placeholder="请选择 护理类型"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in nurseTypeDict"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item prop="bedConnector" label="连接符：" :rules="formRules.connector">
              <div class="form-item-connector">
                <span>房间号</span>
                <el-input v-model="formData.bedConnector" clearable></el-input>
                <span>床位号</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item prop="bedCodeType" label="床位编号方式：">
              <el-radio-group v-model="formData.bedCodeType">
                <el-radio :label="1">按房间计数</el-radio>
                <el-radio :label="2">按楼层计数</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">
        {{ type == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { addFloorApi, updateFloorApi } from '../api/bedManage';
import mixin from './mixin';

export default {
  name: 'BuildingForm',
  mixins: [mixin],
  data() {
    return {
      // 将本地变量转成实例属性，否则mixin里无法访问到
      addApi: addFloorApi,
      updateApi: updateFloorApi,
    };
  },
  watch: {
    'formData.floorRoomNum'(newV, oldV) {
      if (oldV && !newV) {
        this.$refs.formRef.clearValidate(['roomTowardType']);
      }
    },
    'formData.roomBedNum'(newV, oldV) {
      if (oldV && !newV) {
        this.$refs.formRef.clearValidate(['towardType', 'bedTypeId', 'nursingType']);
      }
    },
  },
  created() {
    if (this.type == 'add') {
      this.formData = Object.assign(
        {
          floorCode: '',
          floorRoomNum: '',
          roomTowardType: '',
          roomNameWithConnectorFlag: 1,
          roomConnectorOne: '',
          roomConnectorTwo: '',
          roomBedNum: '',
          towardType: '',
          bedTypeId: '',
          nursingType: '',
          bedConnector: '',
          bedCodeType: 1,
        },
        this.rowData
      );
    } else {
      this.formData = this.rowData;
    }
  },
};
</script>

<style lang="scss" scoped>
@import './common.scss';
</style>
